/** internal storage to keep results of expensive calculations */
const cache = new Map<string, any>();

/**
 * a helper function to run expensive calculations once and reuse the results.
 *
 * @param name an unique identifier for the calculation function (can not use function names for anonymous functions)
 * @param cacheKeys an array of primitive inputs the calculation depends on
 * @param factory the function which is doing the expensive calculation (runs only once per cacheKeys)
 * @returns the result returned from cache or factory function
 */
export const memorize = <T>(name: string, cacheKeys: Array<string | number | boolean>, factory: () => T): T => {
    const id = JSON.stringify({ name, cacheKeys });
    if (cache.has(id)) {
        return cache.get(id);
    }
    const value = factory();
    cache.set(id, value);
    return value;
}
